import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient instance used by the shell and all pilets.
 * Exported here so both `index.tsx` (provider) and `piletLoader.tsx` (PiletApi)
 * reference the same instance — enabling pilets to call `prefetchQuery` before
 * mounting their own route (e.g. prefetching camera list on nav hover).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Never retry client errors (4xx) — they are deterministic failures.
      // Network errors and 5xx are still retried up to 2 times.
      retry: (failureCount, error: any) => {
        const status = error?.status ?? error?.response?.status;
        if (status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});
